import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { LogIn, AlertCircle } from "lucide-react";
import { useAdminAuth } from "../../contexts/AdminAuthContext";

const AdminLogin = () => {
  const { admin, login, loading } = useAdminAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (loading) return null;
  if (admin) return <Navigate to="/admin/dashboard" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      await login(email, password);
      navigate("/admin/dashboard", { replace: true });
    } catch (err) {
      const detail = err?.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Giriş başarısız. Bilgileri kontrol edin.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-rotam-bg flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-10">
          <h1 className="font-heading text-3xl text-rotam-primary font-medium">ROTAM</h1>
          <p className="mt-2 text-xs tracking-[0.25em] uppercase text-rotam-muted">Admin Paneli</p>
        </div>
        <form
          onSubmit={onSubmit}
          data-testid="admin-login-form"
          className="bg-white border border-rotam-border rounded-sm p-8 md:p-10 space-y-6"
        >
          <div>
            <label className="text-xs tracking-[0.18em] uppercase text-rotam-muted">E-posta</label>
            <input
              required
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="admin-login-email"
              className="input-line mt-2"
              autoComplete="username"
            />
          </div>
          <div>
            <label className="text-xs tracking-[0.18em] uppercase text-rotam-muted">Şifre</label>
            <input
              required
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-login-password"
              className="input-line mt-2"
              autoComplete="current-password"
            />
          </div>

          {error && (
            <div
              data-testid="admin-login-error"
              className="flex items-start gap-2 bg-red-50 border border-red-200 text-red-700 text-sm p-3 rounded-sm"
            >
              <AlertCircle size={16} className="mt-0.5 shrink-0" />
              <span>{error}</span>
            </div>
          )}

          <button
            type="submit"
            disabled={submitting}
            data-testid="admin-login-submit"
            className="w-full btn-primary disabled:opacity-60 disabled:cursor-not-allowed"
          >
            <LogIn size={16} />
            {submitting ? "Giriş yapılıyor..." : "Giriş Yap"}
          </button>
        </form>
        <p className="mt-6 text-center text-xs text-rotam-muted">
          Bu alan sadece ROTAM yöneticileri içindir.
        </p>
      </div>
    </div>
  );
};

export default AdminLogin;
